export const MPC_CONTENT_PATH = 'research/infographics/most-popular-car-colors-by-state-data';

export const NAMES_TO_COLOR_CODES = {
  'sea-green': '#36b37e',
  wine: '#8c1a16',
  red: '#ff3030',
  'dark-blue': '#00374d',
  magenta: '#d50661',
  white: '#FFFFFF',
  gray: '#534C4C',
  grey: '#534C4C',
  black: '#000000',
  silver: '#E6E6E6',
  blue: '#1A375A',
  green: '#458A55',
  orange: '#F59442',
  gold: '#967C4B',
  yellow: '#F4BE59',
  purple: '#8A5F9E',
  violet: '#A78BFA',
  pink: '#F9A8D4',
  brown: '#6D4C41',
  indigo: '#5C6BC0',
  default: '#cce4fa',
  'default-focused': '#FFFFFF',
};

export const NATIONWIDE_VIEW_OPTION = 'Nationwide';
export const STATE_VIEW_OPTION = 'State';
